import { useCallback, useState } from 'react';
import getDealStatuses from '../../api/deals/getDealStatuses';
import Select from '../Select/Select';
import {
  DEAL_STATUS_CAR_ISSUED,
  DEAL_STATUS_DOCUMENTS_PROCESSING,
  DEAL_STATUS_WAIRING_REGISTRATION,
  DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
  DEAL_STATUS_WAITING_FOR_PAYMENT,
  DEAL_STATUS_WAITING_FOR_SIGNING_CONTRACT,
  PAYMENT_TYPES_PREPAYMENT_CARD,
  PAYMENT_TYPES_PREPAYMENT_INVOICE,
} from '../../constants';

const SelectDealStatuses = ({ handleSetSelect, handleSetState, style, ...props }) => {
  const [data, setData] = useState([]);
  const onFocus = useCallback(() => {
    getDealStatuses().then((res) => {
      let statuses = res.data?.map((item) => ({ value: item.id, label: item.title }));
      if (
        props.defaultValue.paymentTypeId === PAYMENT_TYPES_PREPAYMENT_INVOICE ||
        props.defaultValue.paymentTypeId === PAYMENT_TYPES_PREPAYMENT_CARD
      ) {
        statuses = [
          { value: DEAL_STATUS_DOCUMENTS_PROCESSING, label: 'ÐÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ðµ Ð´Ð¾Ðº-Ð²' },
          { value: DEAL_STATUS_WAITING_FOR_PAYMENT, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¾Ð¿Ð»Ð°ÑÑ' },
          { value: DEAL_STATUS_WAITING_FOR_SIGNING_CONTRACT, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°' },
          { value: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð½Ð¾ÑÐ°ÑÐ¸Ð°Ð»ÑÐ½ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²' },
          { value: DEAL_STATUS_WAIRING_REGISTRATION, label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ' },
          { value: DEAL_STATUS_CAR_ISSUED, label: 'ÐÐ°ÑÐ¸Ð½Ð° Ð²ÑÐ´Ð°Ð½Ð°' },
        ];
      }
      setData(statuses);
    });
  }, [props.defaultValue.paymentTypeId]);

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={data}
      title={'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸'}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      onFocus={onFocus}
      style={style}
      {...props}
    />
  );
};

export default SelectDealStatuses;
